import { useQuery } from "react-query";
import axios from "axios";

//var authToken = "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6IjJaUXBKM1VwYmpBWVhZR2FYRUpsOGxWMFRPSSIsImtpZCI6IjJaUXBKM1VwYmpBWVhZR2FYRUpsOGxWMFRPSSJ9.eyJhdWQiOiIwMDAwMDAwMy0wMDAwLTBmZjEtY2UwMC0wMDAwMDAwMDAwMDAvb3BlbnN5c3RlbXMxMzEuc2hhcmVwb2ludC5jb21AOWMxY2Q5MDktYTgwMy00Mzg4LWI1Y2MtYTg4NjkyYjU5NTcxIiwiaXNzIjoiMDAwMDAwMDEtMDAwMC0wMDAwLWMwMDAtMDAwMDAwMDAwMDAwQDljMWNkOTA5LWE4MDMtNDM4OC1iNWNjLWE4ODY5MmI1OTU3MSIsImlhdCI6MTY2MzA0MTM2MywibmJmIjoxNjYzMDQxMzYzLCJleHAiOjE2NjMxMjgwNjMsImlkZW50aXR5cHJvdmlkZXIiOiIwMDAwMDAwMS0wMDAwLTAwMDAtYzAwMC0wMDAwMDAwMDAwMDBAOWMxY2Q5MDktYTgwMy00Mzg4LWI1Y2MtYTg4NjkyYjU5NTcxIiwibmFtZWlkIjoiZWMzMDczODAtNTc4OC00OTNkLTgyM2YtNzA0N2QyOTM3ZGVhQDljMWNkOTA5LWE4MDMtNDM4OC1iNWNjLWE4ODY5MmI1OTU3MSIsIm9pZCI6IjI5MzVlZTZlLTI5MzctNDVlYy1iZGI1LTBjZGU4ZGFhNGVmMiIsInN1YiI6IjI5MzVlZTZlLTI5MzctNDVlYy1iZGI1LTBjZGU4ZGFhNGVmMiIsInRydXN0ZWRmb3JkZWxlZ2F0aW9uIjoiZmFsc2UifQ.hj1uxEuC_BQ7cFsFzE_jsO5cM4pvycXQb338t04RCQx71aETkwkKahB1NDu8wtAVeBLVGhFqBIgU4GBrjbOpSWJltIhIK6zyowdXVzdmMPQ9B4gVSXHsTfKMkBnTjydyYKvmgyZCx94rjg9XCj1Bh91L4UlSAumu2NR-BJhjAEBJJYYla_UoLziEahhVDniGYdtX0TXrOpT5ul7CRhKri3dTU90mGtKFml2AwykqzEncL-MJRgMDIQLeoMiPPYlzzKOPsc4vuSwktbARg9-ssSoPWqEjnkxYu4ootZdSOzpDnAByjuEb204GvHLV0HfAkEWzLspOY2p9-lucN2k98A";
//var siteURL = "https://opensystems131.sharepoint.com/sites/PaulsTestSite"

export const useFiles = (ServerRelativeUrl, authToken) => {
 return useQuery(["files",ServerRelativeUrl],
  async () => {

    
   const { data } = await axios.get(`${process.env.REACT_APP_PROD_API_URL}/_api/Web/GetFolderByServerRelativePath(decodedurl='${ServerRelativeUrl}')/files?$orderBy=name`, {headers:{
    "Accept": "application/json;odata=verbose",
    "Authorization": `Bearer ${authToken}`
   }}).catch((error) => {
        console.log(error);
   }); 
   
    for(var i =0; i < data.d.results.length; i++) {
              
        var response = await axios.get(data.d.results[i].ListItemAllFields.__deferred.uri,{headers:{
          "Accept": "application/json;odata=verbose",
          "Authorization": `Bearer ${authToken}`
         }}).catch((error) => {
              console.log(error);
         });


         data.d.results[i].LinkToItem = response.data.d.LinkToItem;
     



    }
   
 
   return data;
 },
 // This tells React-Query that this is Query is part of
   // a paginated component
   { keepPreviousData: true }
 );

};

  /*
    for (var i= 0; i <  response.data.d.results.Length; i++) {
          // Call webservice list item all fields. 
       

      await axios.get(`${siteURL}/_api/Web/GetFileByServerRelativePath(decodedurl='${response.data.d.results[i].ServerRelativeUrl}')/ListItemAllFields`, {headers:{
        "Accept": "application/json;odata=verbose",
        "Authorization": authToken
       }}).then((resp) => 
       {
        response.data.d.results[i].LinkToItem = resp.data.d.LinkToItem;
        data.d.results[i].LinkToItem = resp.data.d.LinkToItem;
       }).catch((error) =>{
        console.log(error);
       }
*/